import { Phone, MessageCircle, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { BUSINESS, TEL_HREF, WA_HREF, MAIL_HREF } from "../../lib/business";

export const Contact = ({ onQuoteClick }) => {
  const cards = [
    {
      icon: Phone,
      label: "Call (Landline)",
      value: BUSINESS.phoneDisplay,
      href: TEL_HREF,
      cta: "Call now",
      testid: "contact-call",
      external: false,
    },
    {
      icon: MessageCircle,
      label: "WhatsApp",
      value: BUSINESS.whatsappDisplay,
      href: WA_HREF,
      cta: "Message on WhatsApp",
      testid: "contact-whatsapp",
      external: true,
    },
    {
      icon: Mail,
      label: "Email",
      value: BUSINESS.email,
      href: MAIL_HREF,
      cta: "Send an email",
      testid: "contact-email",
      external: false,
    },
    {
      icon: MapPin,
      label: "Visit",
      value: BUSINESS.addressShort,
      href: BUSINESS.mapsUrl,
      cta: "Get directions",
      testid: "contact-directions",
      external: true,
    },
  ];

  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-24 md:py-32 bg-white border-t border-[#E5E5E5]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-7">
            <div className="overline">
              <span className="gold-divider mr-3 align-middle" />
              Get in touch
            </div>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-[#1A1A1A] mt-6 leading-[1.05]">
              Ready to manufacture
              <br />
              something worth trusting?
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[#595959] leading-relaxed">
              Share your product idea, volume, or specification — we&apos;ll
              come back with a quote and timeline. For faster response, reach
              us on WhatsApp during business hours.
            </p>
            <button
              data-testid="contact-get-quote"
              onClick={onQuoteClick}
              className="btn-gold rounded-sm mt-6 inline-flex items-center gap-2 h-12 px-7 text-sm font-semibold tracking-wider"
            >
              Request a Quote <ArrowUpRight className="w-4 h-4" />
            </button>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {cards.map((c) => {
            const Icon = c.icon;
            return (
              <a
                key={c.label}
                data-testid={c.testid}
                href={c.href}
                target={c.external ? "_blank" : undefined}
                rel={c.external ? "noreferrer" : undefined}
                className="group block border border-[#E5E5E5] bg-white p-7 transition-all hover:border-[#D4AF37] hover:-translate-y-0.5 hover:shadow-[0_20px_40px_-20px_rgba(26,26,26,0.18)]"
              >
                <div className="flex items-start justify-between">
                  <Icon className="w-6 h-6 text-[#D4AF37]" strokeWidth={1.5} />
                  <ArrowUpRight className="w-4 h-4 text-[#1A1A1A]/30 group-hover:text-[#D4AF37] transition-colors" />
                </div>
                <div className="overline text-[10px] mt-6">{c.label}</div>
                <div className="font-serif-display text-base md:text-lg text-[#1A1A1A] mt-1 leading-snug break-words">
                  {c.value}
                </div>
                <div className="text-xs text-[#595959] mt-4 tracking-wide uppercase">
                  {c.cta} →
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};
